var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subs messages-group"},[_c('subscription-message-header-row',{attrs:{"notificationProp":_vm.notifyAll,"email":_vm.emailSettings},on:{"changenotification":_vm.changeNotification}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }